import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path d="M9.5 3.375C9.15482 3.375 8.875 3.65482 8.875 4C8.875 4.34518 9.15482 4.625 9.5 4.625H12.5C12.8452 4.625 13.125 4.34518 13.125 4C13.125 3.65482 12.8452 3.375 12.5 3.375H9.5Z" />
    <path d="M11 18.75C11.5523 18.75 12 18.3023 12 17.75C12 17.1977 11.5523 16.75 11 16.75C10.4477 16.75 10 17.1977 10 17.75C10 18.3023 10.4477 18.75 11 18.75Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.75 1C4.7835 1 4 1.7835 4 2.75V19.25C4 20.2165 4.7835 21 5.75 21H16.25C17.2165 21 18 20.2165 18 19.25V2.75C18 1.7835 17.2165 1 16.25 1H5.75ZM5.5 2.75C5.5 2.61193 5.61193 2.5 5.75 2.5H16.25C16.3881 2.5 16.5 2.61193 16.5 2.75V14.75H5.5V2.75ZM5.5 16H16.5V19.25C16.5 19.3881 16.3881 19.5 16.25 19.5H5.75C5.61193 19.5 5.5 19.3881 5.5 19.25V16Z"
    />
  </svg>
);
